module.exports = __webpack_public_path__ + "static/media/ThorLoveAndThunder.bc766dd4.mp4";